import React from 'react';
import { format } from 'date-fns';

const FinalDateGroupDisplay = ({ status, finishDate }) => {
  const renderDate = () => (
    <>
      <span>{format(finishDate, 'yyyy-MM-dd')}</span>
      <span>{format(finishDate, 'hh:mm:ss')}</span>
    </>
  );

  switch (status) {
    case 'partialCompleted':
      return renderDate();
    case 'inProgress':
      return <span>Loading</span>;
    case 'allCompleted':
    case 'allFailed':
      return renderDate();
    case 'canceled':
      return <span>N/A</span>;
    default:
      return null;
  }
};

export default FinalDateGroupDisplay;
